import {InjectionToken} from '@angular/core';
import * as SentryAngular from '@sentry/angular';

export const SENTRY_CAPTURE_EXCEPTION = new InjectionToken<typeof SentryAngular.captureException>(
    'SENTRY_CAPTURE_EXCEPTION',
    {
        providedIn: 'root',
        factory: (): typeof SentryAngular.captureException => SentryAngular.captureException
    }
);

export const SENTRY_SET_TAG = new InjectionToken<typeof SentryAngular.setTag>(
    'SENTRY_SET_TAG',
    {
        providedIn: 'root',
        factory: (): typeof SentryAngular.setTag => SentryAngular.setTag
    }
);

export const SENTRY_SET_TAGS = new InjectionToken<typeof SentryAngular.setTags>(
    'SENTRY_SET_TAGS',
    {
        providedIn: 'root',
        factory: (): typeof SentryAngular.setTags => SentryAngular.setTags
    }
);